import { SearchParamsSortOption } from 'src/models';
import { batPercentMap } from '../FilterPanel/config';
import { MarketPlaceTab } from 'src/Pages/MarketplaceV2/Components/MarketTab/configs';
export const ITEM_PER_ROW = 4;
export const ROW_PER_PAGE = 4;
export const ITEM_PER_ROW_TABLET = 3;
export const ROW_PER_PAGE_TABLET = 6;
export const ITEM_PER_PAGE_DESKTOP = ITEM_PER_ROW * ROW_PER_PAGE; // Desktop screen  has 4 column and 4 rows

export const ITEM_PER_PAGE_TABLET = ITEM_PER_ROW_TABLET * ROW_PER_PAGE_TABLET; // Tablet screen has 3 column and 6 rows

export const defaultParams = {
  sort: SearchParamsSortOption.PRICE_PER_BATTLES,
  batPercentMin: batPercentMap['60'].value,
  tab: MarketPlaceTab.HEROES
};